import * as yup from "yup";

import { validator as additionalDataValidator } from "./AdditionalData/validator";
import { validator as applicantDataValidator } from "./ApplicantData/validator";
import { validator as driverDataValidator } from "./DriverData/validator";

export const validator = yup.object({
  ...applicantDataValidator,
  ...driverDataValidator,
  ...additionalDataValidator,
});
